export default __webpack_public_path__ + "static/media/solch.a30c6dc8.png";